import {getFormConfigErrors, getFormPayloadErrors} from "./formValidationHelpers.js";
import {getAnchoredMeanConfigErrors, getAnchoredMeanPayloadErrors} from "./anchoredMeanHelpers.js";
import {getFormScriptConfigErrors} from "./formScriptHelpers.js";
import {getHandoutConfigErrors} from "./handoutHelpers.js";
import {getFrequencyInventoryConfigErrors, getFrequencyInventoryPayloadErrors} from "./frequencyInventoryHelpers.js";
import {getSubscaleProfileConfigErrors, getSubscaleProfilePayloadErrors} from "./subscaleProfileHelpers.js";
import {getOrdinalProfileConfigErrors, getOrdinalProfilePayloadErrors} from "./ordinalProfileHelpers.js";
import {getPairedQuestionnaireConfigErrors, getPairedQuestionnairePayloadErrors} from "./pairedQuestionnaireHelpers.js";

// Specialized response schemas replace ordinary field validation. Additive capabilities
// retain ordinary fields and contribute their own configuration/response constraints.
function getResponseSchema(config) {
	const schemas = [
		[config.ordinalProfile, getOrdinalProfileConfigErrors, getOrdinalProfilePayloadErrors],
		[config.subscaleProfile, getSubscaleProfileConfigErrors, getSubscaleProfilePayloadErrors],
		[config.frequencyInventory, value => getFrequencyInventoryConfigErrors(value.frequencyInventory), getFrequencyInventoryPayloadErrors],
	]
	const schema = schemas.find(([enabled]) => enabled)
	return schema ? {configErrors: schema[1], payloadErrors: schema[2]} : null
}

export function getFormCapabilityConfigErrors(config = {}) {
	const schema = getResponseSchema(config)
	return schema ? schema.configErrors(config) : [
		...getFormConfigErrors(config), ...getFormScriptConfigErrors(config),
		...getHandoutConfigErrors(config), ...getAnchoredMeanConfigErrors(config),
		...getPairedQuestionnaireConfigErrors(config),
	]
}

export function getFormCapabilityPayloadErrors(payload = {}, config = {}) {
	if (config.anchoredMean) {
		const ordinaryAnswers = {...payload.answers}
		for (const id of config.anchoredMean.ratingFieldIds || []) delete ordinaryAnswers[id]
		return [...getFormPayloadErrors({...payload, answers: ordinaryAnswers}, config), ...getAnchoredMeanPayloadErrors(payload, config)]
	}
	const schema = getResponseSchema(config)
	const validate = schema?.payloadErrors || (config.pairedQuestionnaire ? getPairedQuestionnairePayloadErrors : getFormPayloadErrors)
	return validate(payload, config)
}
